import { render, staticRenderFns } from "./CreateCustomerProductDetailsPopUp.vue?vue&type=template&id=8685885a&scoped=true&"
import script from "./CreateCustomerProductDetailsPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerProductDetailsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomerProductDetailsPopUp.vue?vue&type=style&index=0&id=8685885a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8685885a",
  null
  
)

export default component.exports